import React from 'react'
import CommonBanner from "../components/Common Banner Component/HeroBanner"
import TestimonialForm from '../components/TestimonialForm/TestimonialForm'
import Blog from "../components/CardBlog/CardBlog"
import HomeHero from '../components/HomeHero/HomeHero'
import ServicesTextContent from '../components/ServicesTextContent/ServicesTextContent'
import ServicesCard from '../components/ServicesCard/ServicesCard'
import WhyChooseUs from '../components/WhyChooseUs/WhyChooseUs'
import LetsGetStarted from '../components/LetsGetStarted/LetsGetStarted'
import WorkIndustry from '../components/WorkIndustry/WorkIndustry'
import PlainBgText from '../components/PlainBgText/PlainBgText'
import Hero from '../components/HomeHero_/Hero'
import PartnerCompanies from '../components/PartnerCompanies/PartnerCompanies'
import { Helmet } from 'react-helmet'

const WhoWeAreList = [
  "Professional and reliable financial management",
  "Industry experts with years of experience",
  "Dedicated to helping businesses succeed"
]

const industriesServeList = [
  "Construction & Contracting",
  "Manufacturing",
  "Professional Services",
  "Information Technology",
  "Wholesale & Distribution",
  "Finance, Insurance, and Real Estate",
  "Retail",
  "Services",
  "Government and Charitable",
  "Food and Beverage",
  "Transportation, Freight & Logistics",
  "Miscellaneous",
]

function home() {
  return (
    <>
      {/* <CommonBanner
        subHeading="Accounting & bookkeeping"
        Heading="Lotus Accounting"
        Paragraph="Gain financial confidence with our expert tax and accounting services. Whether you are managing a small business or starting a new company, we guarantee that your finances will be optimized to work in your favor."
        btnText="Get Consultation"
        bgImg=""
        bgVideo={true}
        btn={true}
      /> */}

      {/* <HomeHero/> */}
       {/* <CommonBanner
          subHeading=""
          Heading= "We Help You Grow"
          Paragraph="Running a business is more than just making sales—it’s about maximizing profits, managing cash flow, and reducing tax burdens. At Lotus Accounting, we provide expert guidance to help small businesses track revenue, control expenses, and implement smart tax strategies. Our goal is to simplify your financial management, so you can focus on scaling your business with confidence and peace of mind."
          btnText="Get Consultation"
          btnRef={"/contact"}
          btnRefTel={true}
          bgImg="/images/creative/about-b.jpg"
          bgVideo={true}
          btn={true}
          textCenter={true}
        /> */}
        <Helmet>
          <link rel="canonical" href="https://www.lotusaccounting.ca/" />
          <title>
          Lotus Accounting | Tax, Bookkeeping & CPA Services in Toronto
        </title>
        <meta
          name='description'
          content=' Expert CPA accounting, bookkeeping, and tax services in Toronto. Lotus Accounting helps businesses reduce taxes, stay compliant, and grow with confidence.'>
        </meta>
        </Helmet>

        <Hero/>

      <ServicesTextContent
            heading={"Who We Are"}
            content={"At Lotus Accounting, we are not just accountants—we are strategic financial partners committed to your business’s success. Since 2015, our expert team, led by Chandran Somasuntharam, CPA, has been at the forefront of helping small businesses thrive. We specialize in customized accounting, tax, and financial planning solutions designed to optimize profits, minimize tax liabilities, and ensure long-term financial security. With a deep understanding of the challenges entrepreneurs face, we provide the financial expertise and proactive strategies needed to drive sustainable growth and stability."}
            customContent={"At Lotus Accounting, we are not just accountants—we are strategic financial partners committed to your business’s success. Since 2015, our expert team, led by Chandran Somasuntharam, CPA, has been at the forefront of helping small businesses thrive. We specialize in customized accounting, tax, and financial planning solutions designed to optimize profits, minimize tax liabilities, and ensure long-term financial security. With a deep understanding of the challenges entrepreneurs face, we provide the financial expertise and proactive strategies needed to drive sustainable growth and stability."}
            // img={'/images/creative/who-we-are-img.jpg'}
            img={'/images/creative/who-we-are-img-new.webp'}
            shiftRow={true}
            bgColor={"white"}
            bulletList={WhoWeAreList}
            btnText={"Learn More"}
            btnRef="/about"
        />
        <PartnerCompanies/>

      {/* <WhatWeDo/> */}

      {/* <FinancialDropdown/> */}
      
      <PlainBgText
      
      />

      <ServicesCard/>
      
      {/* <DiscoverServices/> */}

      {/* <ServicesTextContent
            heading={"Industries We Serve"}
            img={'/images/creative/industries-we-serve.jpg'}
            shiftRow={true}
            bgColor={"white"}
            TickMarkList={industriesServeList}
            btn={false}
        /> */}

        <WorkIndustry/>


        <WhyChooseUs/>

      {/* <PartnerCompanies/> */}
      
      {/* <Blog/> */}
      <TestimonialForm PartnerCompaniesSection={false}/>
      <LetsGetStarted/>
    </>
  )
}

export default home